// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPlan {
    static getAttributeTypeMap() {
        return PharmacyBiPlan.attributeTypeMap;
    }
}
PharmacyBiPlan.discriminator = undefined;
PharmacyBiPlan.additionalProperties = false;
PharmacyBiPlan.attributeTypeMap = [
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "string"
    },
    {
        "name": "groupNo",
        "baseName": "groupNo",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "priority",
        "baseName": "priority",
        "type": "string"
    },
    {
        "name": "renewalMonth",
        "baseName": "renewalMonth",
        "type": "string"
    },
    {
        "name": "renewalType",
        "baseName": "renewalType",
        "type": "string"
    },
    {
        "name": "terminationDate",
        "baseName": "terminationDate",
        "type": "string"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPlan.js.map